import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing(1)};
  width: 100%;
  ${(p) => p.theme.breakpoints.up('sm')} {
    min-width: ${(p) => p.theme.spacing(60)};
  }
`;

export const Header = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Title = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(p) => p.theme.spacing(0.5)};
  color: ${(p) => p.theme.palette.common.black};
  font-size: ${(p) => p.theme.typography.body2};
  font-weight: 400;
  margin-left: ${(p) => p.theme.spacing(1)};

  > svg {
    color: ${(p) => p.theme.palette.primary[500]};
  }
`;

export const Action = styled(Button)`
  color: ${(p) => p.theme.palette.primary[500]};
  font-size: ${(p) => p.theme.typography.caption};
  font-weight: 400;
`;

export const CardBodyTitleWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(p) => p.theme.spacing(1)};
`;

export const CardBodyTitle = styled('div')`
  color: ${(p) => p.theme.palette.primary[500]};
  font-size: ${(p) => p.theme.typography.body2};
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
`;

export const CardBodyTeam = styled('div')`
  color: ${(p) => p.theme.palette.grey[700]};
  font-size: ${(p) => p.theme.typography.caption};
  font-weight: 400;
`;

export const CardBodyDescription = styled('div')`
  color: ${(p) => p.theme.palette.text.secondary};
  font-size: ${(p) => p.theme.typography.caption};
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: ${(p) => p.theme.spacing(19)};
  text-align: start;
`;

export const CardBodyAiSearch = styled('div')`
  color: ${(p) => p.theme.palette.grey[700]};
  font-size: ${(p) => p.theme.typography.caption};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: ${(p) => p.theme.spacing(11)};
  text-align: start;
`;

export const CardBodyDate = styled('div')`
  color: ${(p) => p.theme.palette.primary[500]};
  text-overflow: ellipsis;
  font-size: ${(p) => p.theme.typography.caption};
  color: ${(p) => p.theme.palette.grey[700]};
  width: ${(p) => p.theme.spacing(10)};
`;

export const CardBodyTotalRecords = styled('div')`
  color: ${(p) => p.theme.palette.grey[700]};
  font-size: ${(p) => p.theme.typography.caption};
`;

export const CardBodyDateAndTime = styled('div')`
  color: ${(p) => p.theme.palette.primary[500]};
  text-overflow: ellipsis;
  font-size: ${(p) => p.theme.typography.body2};
  font-weight: 600;
  width: ${(p) => p.theme.spacing(14)};
`;

export const CardHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  padding: ${(p) => p.theme.spacing(0.5, 1.5)};
  border-bottom: 1px solid ${(p) => p.theme.palette.grey['400']};
`;

export const ColumnHeader = styled('div')`
  display: flex;
  align-items: center;
  padding: 5px;
  font-size: ${(p) => p.theme.typography.caption};
  color: ${(p) => p.theme.palette.grey[500]};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: start;

  &:last-child {
    justify-content: flex-end;
  }
`;

export const CardBody = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: ${(p) => p.theme.spacing(1.5)} ${(p) => p.theme.spacing(2)};

  &:hover {
    background: ${(p) => p.theme.palette.primary[50]};
  }
`;

export const EmptyCardBody = styled('div')`
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(p) => p.theme.spacing(3)};
`;

export const EmptyImage = styled('div')<{ src: string }>`
  background: url(${(p) => p.src});
  width: 100%;
  height: 10vh;
  background-size: 100% 100%;
`;
